import { View } from 'foundations-components/components/View';
import AnimatedBg from './AnimatedBg';
import styled from 'styled-components';

// Adds top margin only between adjacent property skeleton items (not to the first one)
import { jsx as _jsx } from "react/jsx-runtime";
const PropertySkeletonWrapper = styled.div.withConfig({
  displayName: "PropertiesListSkeleton__PropertySkeletonWrapper",
  componentId: "sc-1w9irj-0"
})(["& + &{margin-block-start:9px;}"]);
const PropertiesListSkeleton = ({
  numberOfProperties
}) => {
  return /*#__PURE__*/_jsx(View, {
    children: Array.from({
      length: numberOfProperties
    }).map((_, index) => /*#__PURE__*/_jsx(PropertySkeletonWrapper, {
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: index % 2 === 0 ? '200px' : '160px',
        maxInlineSize: "100%",
        blockSize: "16px",
        borderRadius: "100",
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(AnimatedBg, {})
      })
    }, index))
  });
};
export default PropertiesListSkeleton;